module.exports = __webpack_public_path__ + "static/media/black_dragon.bc305876.webp";